
import React, { useEffect } from 'react';
import { tracker } from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import '@fontsource/nunito';
import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';
import LoginContainer from '../components/pages/login/LoginContainer';
import Routes from './Routes';
import { appName } from 'custom/constants';
import ChangePasswordContainer from 'components/pages/login/changepassword/ChangePasswordContainer';
import ResetPasswordContainer from 'components/pages/login/resetpassword/ResetPasswordContainer';
import DocUploadContainer from 'components/pages/docUpload/DocUploadContainer';
import WeightInputTest1 from 'components/pages/weightInputTest/WeightInputTest1';
import WeightInputTest2 from 'components/pages/weightInputTest/WeightInputTest2';
import WeightInputTest3 from 'components/pages/weightInputTest/WeightInputTest3';
import WeightInputTest4 from 'components/pages/weightInputTest/WeightInputTest4';
import ConsigneeRegistrationForm from 'components/public/ConsigneeRegistrationForm';
import cookies from 'utils/cookies';

const isProd = process.env.REACT_APP_STAGE === 'prod';

// OpenReplay tracker configuration
if (isProd) {
  tracker.configure({
    projectKey: 'r2RIlababopHfSWD1U17',
    ingestPoint: 'https://weblytics.orgadynamics.com/ingest',
    network: {
      capturePayload: true,
      failuresOnly: false,
      ignoreHeaders: ['Authorization', 'Cookie'],
      sanitizer: (data) => {
        // Optional: redact sensitive information
        return data;
      },
    },
  });
  tracker.use(trackerAssist());
}

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (isProd) {
      tracker.event('pageview', {
        path: location.pathname,
        location,
      });
    }
  }, [location]);
  return null;
}

const App = () => {
  useEffect(() => {
    if (isProd) {
      const userID = cookies.get('user');
      tracker.start().then(() => {
        tracker.setUserID(userID);
        tracker.setMetadata('station', cookies.get('station'));
        tracker.setMetadata('station_code', cookies.get('station_code'));
        tracker.setMetadata('company', cookies.get('company'));
        tracker.setMetadata('company_name', cookies.get('company_name'));
        tracker.setMetadata('username', cookies.get('username'));
        tracker.setMetadata('role', cookies.get('role'));
        tracker.setMetadata('name', cookies.get('name'));
      });
    }
    // Set document title for login page
    const currentPath = window.location.pathname;
    if(currentPath.includes('/login')) {
      document.title = 'Login' + ' | ' + appName;
    }
  }, []);

  return (
    <BrowserRouter>
      <RouteTracker />
      <Switch>
        <Route path='/login' component={LoginContainer} />
        <Route path='/change-password/:id?/:token?' component={ChangePasswordContainer} />
        <Route path='/reset-password' component={ResetPasswordContainer} />
        <Route path='/doc-request/:token' component={DocUploadContainer} />
        <Route path='/consignee-registration' component={ConsigneeRegistrationForm} />
        <Route path='/weight-input-tester' component={WeightInputTest2} />
        <Route path='/weight-input-tester2' component={WeightInputTest1} />
        <Route path='/weight-input-tester3' component={WeightInputTest3} />
        <Route path='/weight-input-tester4' component={WeightInputTest4} />
        <Route path='/*' component={Routes} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;